import Image from "next/image";

interface StatusItemProps {
  icon: string;
  title: string;
  subtitle: string;
  status: "success" | "warning" | "error" | "count";
  count?: number;
}

export const StatusItem = ({
  icon,
  title,
  subtitle,
  status,
  count,
}: StatusItemProps) => {
  const getStatusIcon = () => {
    switch (status) {
      case "success":
        return (
          <Image
            className="mr-2"
            src="/icons/greenTick.svg"
            alt="success icon"
            width={25}
            height={25}
          />
        );
      case "warning":
        return (
          <Image
            className="mr-2"
            src="/icons/warningYellow.svg"
            alt="warning icon"
            width={25}
            height={25}
          />
        );
      case "error":
        return (
          <Image
            className="mr-2"
            src="/icons/notFoundRed.svg"
            alt="error icon"
            width={25}
            height={25}
          />
        );
      case "count":
        return (
          <span className="mr-2 rounded-full bg-red-700 min-w-[24px] min-h-[24px] text-center py-1 text-xs font-medium text-white group-hover:text-white">
            {count}
          </span>
        );
      default:
        return null;
    }
  };

  return (
    <li className="flex items-center justify-between gap-3 rounded-xl p-2">
      <div className="flex items-center gap-3">
        <Image
          className="rounded-lg group-hover:hidden bg-white p-[12px] size-[50px] shadow-xl group-hover:bg-[#9fa3c6]"
          src={`/icons/${icon}.svg`}
          alt={`${icon} icon`}
          width={50}
          height={50}
        />
        <Image
          className="rounded-lg hidden group-hover:block bg-white p-[12px] size-[50px] shadow-xl group-hover:bg-[#9fa3c6]"
          src={`/icons/${icon}Dark.svg`}
          alt={`${icon} icon`}
          width={50}
          height={50}
        />
        <div className="flex flex-col">
          <span className="text-[16px] text-black group-hover:text-white">
            {title}
          </span>
          <span className="text-[12px] text-gray-800 group-hover:text-white">
            {subtitle}
          </span>
        </div>
      </div>
      {getStatusIcon()}
    </li>
  );
};